import { ControlStatusChangeReason } from '@/gen/inventory/v1/control_service_pb'

const reasonLabel: Record<ControlStatusChangeReason, string> = {
  [ControlStatusChangeReason.UNSPECIFIED]: 'Unspecified',
  [ControlStatusChangeReason.BUSINESS_DECISION]: 'Business decision',
  [ControlStatusChangeReason.INCORRECT_AI_EVALUATION]: 'Incorrect AI evaluation',
  [ControlStatusChangeReason.VENDOR_ATTESTED]: 'Vendor attested',
}

export const CONTROL_STATUS_CHANGE_MODAL_LABELS = {
  reasonLabel,
  aiEvaluationNotSupported: 'The AI drew a conclusion not supported by evidence.',
  aiEvaluationMissedEvidence: 'The AI missed evidence that supports this status.',
  reasonOptionDescription: 'Deliberate choice to override the AI evaluation.',
  modalTitle: 'Why did you change the control status?',
  confirmChange: 'Confirm change',
  selectReason: 'Select a reason',
  feedbackNote: 'Your feedback will be shared with Lema to improve future AI evaluations.',
  commentLabel: 'Add a comment',
  commentPlaceholder: 'Visible in activity log for audit purposes',
  toastTitle: 'Status updated',
  statusColumnCurrent: 'Current',
  statusColumnNew: 'New status',
} as const
